module.exports = __webpack_public_path__ + "scripts/outline-icons.ttf?f3334251";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/fonts/outline-icons.ttf
// module id = 216
// module chunks = 1